/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  CreateCommunicationTargetDto,
  DataEnvelopeOfCommunicationTargetDto,
  DataEnvelopeOfIEnumerableOfCommunicationTargetDto,
  DataEnvelopeOfObject,
  ErrorEnvelope,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const addCommunicationTarget = (
  communicationUuid: string,
  createCommunicationTargetDto: CreateCommunicationTargetDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    {
      url: `/v1/communications/${communicationUuid}/targets`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCommunicationTargetDto,
      signal,
    },
    options,
  )
}

export const getAddCommunicationTargetMutationKey = () => ['addCommunicationTarget'] as const

export const getAddCommunicationTargetMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addCommunicationTarget>>,
    TError,
    AddCommunicationTargetMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof addCommunicationTarget>>,
  TError,
  AddCommunicationTargetMutationVariables,
  TContext
> => {
  const mutationKey = getAddCommunicationTargetMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addCommunicationTarget>>,
    AddCommunicationTargetMutationVariables
  > = (props) => {
    const { communicationUuid, data } = props ?? {}

    return addCommunicationTarget(communicationUuid, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AddCommunicationTargetMutationResult = NonNullable<
  Awaited<ReturnType<typeof addCommunicationTarget>>
>
export type AddCommunicationTargetMutationBody = CreateCommunicationTargetDto
export type AddCommunicationTargetMutationError = ErrorEnvelope
export type AddCommunicationTargetMutationVariables = {
  communicationUuid: string
  data: CreateCommunicationTargetDto
}

export const useAddCommunicationTarget = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addCommunicationTarget>>,
      TError,
      AddCommunicationTargetMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addCommunicationTarget>>,
  TError,
  AddCommunicationTargetMutationVariables,
  TContext
> => {
  return useMutation(getAddCommunicationTargetMutationOptions(options), queryClient)
}
export const listCommunicationTargets = (
  communicationUuid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfIEnumerableOfCommunicationTargetDto>(
    { url: `/v1/communications/${communicationUuid}/targets`, method: 'GET', signal },
    options,
  )
}

export const getListCommunicationTargetsQueryKey = (communicationUuid: string) => {
  return [`/v1/communications/${communicationUuid}/targets`] as const
}

export const getListCommunicationTargetsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCommunicationTargets>>,
  TError = ErrorEnvelope,
>(
  communicationUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCommunicationTargets>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListCommunicationTargetsQueryKey(communicationUuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCommunicationTargets>>> = ({
    signal,
  }) => listCommunicationTargets(communicationUuid, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: communicationUuid !== null && communicationUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listCommunicationTargets>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type ListCommunicationTargetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCommunicationTargets>>
>
export type ListCommunicationTargetsQueryError = ErrorEnvelope

export function useListCommunicationTargets<
  TData = Awaited<ReturnType<typeof listCommunicationTargets>>,
  TError = ErrorEnvelope,
>(
  communicationUuid: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCommunicationTargets>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCommunicationTargets>>,
          TError,
          Awaited<ReturnType<typeof listCommunicationTargets>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCommunicationTargets<
  TData = Awaited<ReturnType<typeof listCommunicationTargets>>,
  TError = ErrorEnvelope,
>(
  communicationUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCommunicationTargets>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCommunicationTargets>>,
          TError,
          Awaited<ReturnType<typeof listCommunicationTargets>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCommunicationTargets<
  TData = Awaited<ReturnType<typeof listCommunicationTargets>>,
  TError = ErrorEnvelope,
>(
  communicationUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCommunicationTargets>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCommunicationTargets<
  TData = Awaited<ReturnType<typeof listCommunicationTargets>>,
  TError = ErrorEnvelope,
>(
  communicationUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCommunicationTargets>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListCommunicationTargetsQueryOptions(communicationUuid, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const removeCommunicationTarget = (
  communicationUuid: string,
  targetUuid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    {
      url: `/v1/communications/${communicationUuid}/targets/${targetUuid}`,
      method: 'DELETE',
      signal,
    },
    options,
  )
}

export const getRemoveCommunicationTargetMutationKey = () => ['removeCommunicationTarget'] as const

export const getRemoveCommunicationTargetMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeCommunicationTarget>>,
    TError,
    RemoveCommunicationTargetMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeCommunicationTarget>>,
  TError,
  RemoveCommunicationTargetMutationVariables,
  TContext
> => {
  const mutationKey = getRemoveCommunicationTargetMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeCommunicationTarget>>,
    RemoveCommunicationTargetMutationVariables
  > = (props) => {
    const { communicationUuid, targetUuid } = props ?? {}

    return removeCommunicationTarget(communicationUuid, targetUuid, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type RemoveCommunicationTargetMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeCommunicationTarget>>
>

export type RemoveCommunicationTargetMutationError = ErrorEnvelope
export type RemoveCommunicationTargetMutationVariables = {
  communicationUuid: string
  targetUuid: string
}

export const useRemoveCommunicationTarget = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeCommunicationTarget>>,
      TError,
      RemoveCommunicationTargetMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeCommunicationTarget>>,
  TError,
  RemoveCommunicationTargetMutationVariables,
  TContext
> => {
  return useMutation(getRemoveCommunicationTargetMutationOptions(options), queryClient)
}
export const toggleCommunicationTargetActive = (
  communicationUuid: string,
  targetUuid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationTargetDto>(
    {
      url: `/v1/communications/${communicationUuid}/targets/${targetUuid}/toggle-active`,
      method: 'POST',
      signal,
    },
    options,
  )
}

export const getToggleCommunicationTargetActiveMutationKey = () =>
  ['toggleCommunicationTargetActive'] as const

export const getToggleCommunicationTargetActiveMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleCommunicationTargetActive>>,
    TError,
    ToggleCommunicationTargetActiveMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof toggleCommunicationTargetActive>>,
  TError,
  ToggleCommunicationTargetActiveMutationVariables,
  TContext
> => {
  const mutationKey = getToggleCommunicationTargetActiveMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof toggleCommunicationTargetActive>>,
    ToggleCommunicationTargetActiveMutationVariables
  > = (props) => {
    const { communicationUuid, targetUuid } = props ?? {}

    return toggleCommunicationTargetActive(communicationUuid, targetUuid, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ToggleCommunicationTargetActiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof toggleCommunicationTargetActive>>
>

export type ToggleCommunicationTargetActiveMutationError = ErrorEnvelope
export type ToggleCommunicationTargetActiveMutationVariables = {
  communicationUuid: string
  targetUuid: string
}

export const useToggleCommunicationTargetActive = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof toggleCommunicationTargetActive>>,
      TError,
      ToggleCommunicationTargetActiveMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof toggleCommunicationTargetActive>>,
  TError,
  ToggleCommunicationTargetActiveMutationVariables,
  TContext
> => {
  return useMutation(getToggleCommunicationTargetActiveMutationOptions(options), queryClient)
}
